import script from "./NavbarCoachingIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavbarCoachingIcon.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./NavbarCoachingIcon.vue?vue&type=style&index=0&id=55b14eb3&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__